import Amazon from "@workspace/ui/icons/amazon";
import FiveStar from "@workspace/ui/icons/five-star";
import Star from "@workspace/ui/icons/star";
import Logo from "@workspace/ui/icons/logo";
import Facebook from "@workspace/ui/icons/facebook";
import Instagram from "@workspace/ui/icons/instagram";
import Youtube from "@workspace/ui/icons/youtube";
import Tiktok from "@workspace/ui/icons/tiktok";
import Shipping from "@workspace/ui/icons/shipping";
import Eligible from "@workspace/ui/icons/eligible";
import Check from "@workspace/ui/icons/check";
import Cross from "@workspace/ui/icons/cross";
import Trust from "@workspace/ui/icons/trust";
import SquareArrow from "@workspace/ui/icons/squareArrow";
import Bloomberg from "@workspace/ui/icons/bloomberg";
import Entrepreneur from "@workspace/ui/icons/entrepreneur";
import Forbes from "@workspace/ui/icons/forbes";
import Washington from "@workspace/ui/icons/washington";
import Week from "@workspace/ui/icons/week";
import FertilityMonitor from "@workspace/ui/icons/fertility-monitor";
import IphoneAttachmentClip from "@workspace/ui/icons/iphone-attachment-clip";
import TestStrips from "@workspace/ui/icons/test-strips";
import App from "@workspace/ui/icons/app";
import BatteryIcon from "@workspace/ui/icons/Battery";
import CompactIcon from "@workspace/ui/icons/Compact";
import WirelessIcon from "@workspace/ui/icons/Wireless";
import ChevronDown from "@workspace/ui/icons/chevron-down";
import IconArrowLeft from "@workspace/ui/icons/icon-arrow-left";
import IconArrowRight from "@workspace/ui/icons/icon-arrow-right";
import IconArrowUp from "@workspace/ui/icons/icon-arrow-up";
import IconArrowDown from "@workspace/ui/icons/icon-arrow-down";
import IconArrowExpand from "@workspace/ui/icons/icon-arrow-expand";
import IconChevronLeftNew from "@workspace/ui/icons/icon-chevron-left-new";
import IconChevronRightNew from "@workspace/ui/icons/icon-chevron-right-new";
import IconChevronUp from "@workspace/ui/icons/icon-chevron-up";
import IconChevronDownNew from "@workspace/ui/icons/icon-chevron-down-new";
import IconPlus from "@workspace/ui/icons/icon-plus";
import IconPlusSmall from "@workspace/ui/icons/icon-plus-small";
import IconMinus from "@workspace/ui/icons/icon-minus";
import IconMinusSmall from "@workspace/ui/icons/icon-minus-small";
import IconCloseBig from "@workspace/ui/icons/icon-close-big";
import IconCloseSmallNew from "@workspace/ui/icons/icon-close-small-new";
import IconLinkedin from "@workspace/ui/icons/icon-linkedin-new";
import IconYoutubeNew from "@workspace/ui/icons/icon-youtube-new";
import IconFacebookNew from "@workspace/ui/icons/icon-facebook-new";
import IconInstagramNew from "@workspace/ui/icons/icon-instagram-new";
import IconX from "@workspace/ui/icons/icon-x";
import IconLinkSocial from "@workspace/ui/icons/icon-link-social";
import IconInfo from "@workspace/ui/icons/icon-info-new";
import IconInfoFilled from "@workspace/ui/icons/icon-info-filled";
import IconMenu from "@workspace/ui/icons/icon-menu";
import IconBell from "@workspace/ui/icons/icon-bell";
import IconCheckbox from "@workspace/ui/icons/icon-checkbox";
import IconTick from "@workspace/ui/icons/icon-tick";
import IconThumbsUp from "@workspace/ui/icons/icon-thumbs-up";
import IconThumbsDown from "@workspace/ui/icons/icon-thumbs-down";
import IconDott from "@workspace/ui/icons/icon-dott";
import IconHeart from "@workspace/ui/icons/icon-heart-new";
import IconHeartOutlined from "@workspace/ui/icons/icon-heart-outlined";
import IconDrop from "@workspace/ui/icons/icon-drop";
import IconFlower from "@workspace/ui/icons/icon-flower";
import IconCalendar from "@workspace/ui/icons/icon-calendar";
import IconShippingNew from "@workspace/ui/icons/icon-shipping-new";
import IconDeliveryTruck from "@workspace/ui/icons/icon-delivery-truck";
import IconGift from "@workspace/ui/icons/icon-gift";
import IconBox from "@workspace/ui/icons/icon-box";
import IconDownload from "@workspace/ui/icons/icon-download";
import IconFilter from "@workspace/ui/icons/icon-filter";
import IconClock from "@workspace/ui/icons/icon-clock";
import IconSecure from "@workspace/ui/icons/icon-secure";
import IconLink from "@workspace/ui/icons/icon-link";
import IconMail from "@workspace/ui/icons/icon-mail";
import IconStarFilled from "@workspace/ui/icons/icon-star-filled";
import IconStarHalf from "@workspace/ui/icons/icon-star-half";
import IconPlayFilled from "@workspace/ui/icons/icon-play-filled";
import IconPlayOutlined from "@workspace/ui/icons/icon-play-outlined";
import IconGemstone from "@workspace/ui/icons/icon-gemstone";
import IconEducation from "@workspace/ui/icons/icon-education";
import IconTrophy from "@workspace/ui/icons/icon-trophy";
import IconSpeechBubble from "@workspace/ui/icons/icon-speech-bubble";
import IconSorting from "@workspace/ui/icons/icon-sorting";
import IconQuote from "@workspace/ui/icons/icon-quote";
import IconMeasure from "@workspace/ui/icons/icon-measure";
import IconFollicle from "@workspace/ui/icons/icon-follicle";
import IconTest from "@workspace/ui/icons/icon-test";
import IconEmbrio from "@workspace/ui/icons/icon-embrio";
import IconFertille from "@workspace/ui/icons/icon-fertille";
import IconAppStoreBadge from "@workspace/ui/icons/icon-app-store-badge";
import IconGooglePlayBadge from "@workspace/ui/icons/icon-google-play-badge";

export const icons: Record<string, React.ComponentType<any>> = {
  amazon: Amazon,
  fiveStar: FiveStar,
  star: Star,
  logo: Logo,
  facebook: Facebook,
  instagram: Instagram,
  youtube: Youtube,
  tiktok: Tiktok,
  eligible: Eligible,
  shipping: Shipping,
  "fertility-monitor": FertilityMonitor,
  "iphone-attachment-clip": IphoneAttachmentClip,
  "test-strips": TestStrips,
  battery: BatteryIcon,
  compact: CompactIcon,
  wireless: WirelessIcon,
  app: App,
  check: Check,
  cross: Cross,
  trust: Trust,
  arrow: SquareArrow,
  bloomberg: Bloomberg,
  entrepreneur: Entrepreneur,
  forbes: Forbes,
  washington: Washington,
  week: Week,
  "chevron-down": ChevronDown,
  "icon-arrow-left": IconArrowLeft,
  "icon-arrow-right": IconArrowRight,
  "icon-arrow-up": IconArrowUp,
  "icon-arrow-down": IconArrowDown,
  "icon-arrow-expand": IconArrowExpand,
  "icon-chevron-left": IconChevronLeftNew,
  "icon-chevron-right": IconChevronRightNew,
  "icon-chevron-up": IconChevronUp,
  "icon-chevron-down": IconChevronDownNew,
  "icon-plus": IconPlus,
  "icon-plus-small": IconPlusSmall,
  "icon-minus": IconMinus,
  "icon-minus-small": IconMinusSmall,
  "icon-close-big": IconCloseBig,
  "icon-close-small": IconCloseSmallNew,
  "icon-linkedin": IconLinkedin,
  "icon-youtube": IconYoutubeNew,
  "icon-facebook": IconFacebookNew,
  "icon-instagram": IconInstagramNew,
  "icon-x": IconX,
  "icon-link-social": IconLinkSocial,
  "icon-info": IconInfo,
  "icon-info-filled": IconInfoFilled,
  "icon-menu": IconMenu,
  "icon-bell": IconBell,
  "icon-checkbox": IconCheckbox,
  "icon-tick": IconTick,
  "icon-thumbs-up": IconThumbsUp,
  "icon-thumbs-down": IconThumbsDown,
  "icon-dott": IconDott,
  "icon-heart": IconHeart,
  "icon-heart-outlined": IconHeartOutlined,
  "icon-drop": IconDrop,
  "icon-flower": IconFlower,
  "icon-calendar": IconCalendar,
  "icon-shipping": IconShippingNew,
  "icon-delivery-truck": IconDeliveryTruck,
  "icon-gift": IconGift,
  "icon-box": IconBox,
  "icon-download": IconDownload,
  "icon-filter": IconFilter,
  "icon-clock": IconClock,
  "icon-secure": IconSecure,
  "icon-link": IconLink,
  "icon-mail": IconMail,
  "icon-star-filled": IconStarFilled,
  "icon-star-half": IconStarHalf,
  "icon-play-filled": IconPlayFilled,
  "icon-play-outlined": IconPlayOutlined,
  "icon-gemstone": IconGemstone,
  "icon-education": IconEducation,
  "icon-trophy": IconTrophy,
  "icon-speech-bubble": IconSpeechBubble,
  "icon-sorting": IconSorting,
  "icon-quote": IconQuote,
  "icon-measure": IconMeasure,
  "icon-follicle": IconFollicle,
  "icon-test": IconTest,
  "icon-embrio": IconEmbrio,
  "icon-fertille": IconFertille,
  "icon-app-store-badge": IconAppStoreBadge,
  "icon-google-play-badge": IconGooglePlayBadge,
};
